module.exports = __webpack_public_path__ + "static/media/PI_Brain_White.c5d5cfed.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/PI_Brain_White.png
// module id = 4128
// module chunks = 0